import { yupResolver } from '@hookform/resolvers/yup';
import { ResponsiveStyleValue } from '@mui/system';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useOryUserLogin } from '../../../../ory/hooks/oryUserLogin/useOryUserLogin';
import { useLoginFlowButtons } from '../../hook/useLoginFlowButtons';
import {
  defaultValues,
  FormFieldNames,
  getMFARecoveryFormValidationScheme,
  IMFARecoveryFormData,
} from './validationSchema';

export interface IUseMFARecoveryForm {
  formSubmit: (values: IMFARecoveryFormData) => Promise<void>;
  formData: UseFormReturn<IMFARecoveryFormData, any, undefined>;
  isOryApiFetching: boolean;
  buttonsDirection: ResponsiveStyleValue<'row' | 'row-reverse' | 'column' | 'column-reverse'>;
  buttonsSpacing: number;
}

export interface IUseMFARecoveryFormProps {
  onSuccess?: () => void;
}

export function useMFARecoveryForm(props: IUseMFARecoveryFormProps): IUseMFARecoveryForm {
  const { formatMessage } = useIntl();

  const { buttonsDirection, buttonsSpacing } = useLoginFlowButtons();
  const { finishLoginWithSecondFactorRecoveryCode, isOryApiFetching } = useOryUserLogin();

  const formData = useForm<IMFARecoveryFormData>({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(getMFARecoveryFormValidationScheme(formatMessage)),
  });

  const formSubmit = async (values: IMFARecoveryFormData) => {
    await finishLoginWithSecondFactorRecoveryCode(
      { totpRecoveryCode: values.totpRecoveryCode },
      { fieldName: FormFieldNames.TotpRecoveryCode, formData },
      props.onSuccess
    );
  };

  return {
    buttonsDirection,
    buttonsSpacing,
    formData,
    formSubmit,
    isOryApiFetching,
  };
}
